// src/components/LoggedOut/HeaderLogic/HeaderBar.jsx

import React, { useState } from "react";
import { Input, Badge, Button } from "antd";
import {
  MenuOutlined,
  SearchOutlined,
  LoginOutlined,
  ContactsOutlined,
  FilterOutlined,
  HeartOutlined,
} from "@ant-design/icons";
import { Link, useLocation } from "react-router-dom";
import logoMercanteo from "../../../images/logo1.PNG";
import "../../../styles/HeaderBar.css";

// Importamos el ContactModal y AppDownload
import ContactModal from "../../LoggedOut/ModalContact";
import AppDownload from "../../Shared/AppDownload";

export default function HeaderBar({
  isMobile,
  searchText,
  onSearchTextChange,
  handleSearch,
  favoritesCount,
  openFavoritesDrawer,
  handleLogin,
  // handleContactos ya no se usa para redireccionar, abriremos el modal directamente
  // toggleFilterDrawer,
  // toggleMenuDrawer,
  toggleFilterDrawer,
  toggleMenuDrawer,
}) {
  // Detectamos la ruta actual
  const location = useLocation();
  const onLoginRoute = location.pathname === "/login";

  // Estado local para controlar el ContactModal y el AppDownload
  const [isContactModalVisible, setIsContactModalVisible] = useState(false);
  const [isAppDownloadVisible, setIsAppDownloadVisible] = useState(false);

  // Función para abrir el modal de "Contáctanos"
  const showContactModal = () => {
    setIsContactModalVisible(true);
  };

  // Cerrar el modal
  const handleContactCancel = () => {
    setIsContactModalVisible(false);
  };

  // Al pulsar "Descargar App" dentro del modal, cerramos el modal y mostramos AppDownload
  const handleDownloadApp = () => {
    setIsContactModalVisible(false);
    setIsAppDownloadVisible(true);
  };

  return (
    <div className="mpl-header">
      <div className="mpl-header-left">
        {isMobile ? (
          <>
            <Button
              type="text"
              icon={<MenuOutlined className="mpl-icon-white" />}
              className="mpl-btn-menu"
              onClick={toggleMenuDrawer}
            />
            <div className="mpl-logo-container-mobile">
              {/* El logo redirige a "/" */}
              <Link to="/">
                <img
                  src={logoMercanteo}
                  alt="Logo Mercanteo México"
                  className="mpl-logo-image-mobile"
                />
              </Link>
            </div>
          </>
        ) : (
          <div className="mpl-logo-container">
            <Link to="/">
              <img
                src={logoMercanteo}
                alt="Logo Mercanteo México"
                className="mpl-logo-image"
              />
              <span className="mpl-logo-text">Mercanteo México</span>
            </Link>
          </div>
        )}
      </div>

      {/* Barra de búsqueda */}
      <div
        className={
          isMobile
            ? "mpl-search-wrapper-mobile"
            : "mpl-search-wrapper-desktop"
        }
        style={{ flex: 1, padding: isMobile ? "0 8px" : "0 24px" }}
      >
        <Input
          placeholder="Buscar productos… Marca, Modelo"
          allowClear
          value={searchText}
          onChange={(e) => onSearchTextChange(e.target.value)}
          onPressEnter={handleSearch}
          className={
            isMobile
              ? "mpl-search-input-mobile"
              : "mpl-search-input-desktop"
          }
          addonAfter={
            <span className="mpl-search-addons">
              <Badge count={favoritesCount} size="small">
                <HeartOutlined
                  className="mpl-heart-icon"
                  onClick={openFavoritesDrawer}
                  aria-label="Abrir favoritos"
                  style={{ color: "#e0245e", fontSize: isMobile ? 18 : 20 }}
                />
              </Badge>
              <Button
                type="primary"
                shape="circle"
                icon={<SearchOutlined />}
                onClick={handleSearch}
                className={
                  isMobile
                    ? "mpl-search-btn-mobile"
                    : "mpl-search-btn-desktop"
                }
                aria-label="Buscar"
              />
            </span>
          }
        />
      </div>

      <div className="mpl-header-right">
        {isMobile ? (
          // En móvil, solo mostrar LOGIN si NO estamos en /login
          !onLoginRoute && (
            <Button
              type="text"
              icon={<LoginOutlined className="mpl-icon-white" />}
              onClick={handleLogin}
              className="mpl-btn-login"
              aria-label="Login"
            />
          )
        ) : (
          <>
            {/* Botón "Contáctanos" que ahora abre el ContactModal */}
            <Button
              type="text"
              icon={<ContactsOutlined className="mpl-icon-white" />}
              onClick={showContactModal}
              className="mpl-btn-header-desktop"
            >
              <span className="mpl-btn-text-desktop">Contáctanos</span>
            </Button>

            {/* Mostrar “Filtros” solo si NO estamos en /login */}
            {!onLoginRoute && (
              <Button
                type="text"
                icon={<FilterOutlined className="mpl-icon-white" />}
                onClick={toggleFilterDrawer}
                className="mpl-btn-header-desktop"
              >
                <span className="mpl-btn-text-desktop">Filtros</span>
              </Button>
            )}

            {/* Mostrar “Login” solo si NO estamos en /login */}
            {!onLoginRoute && (
              <Button
                type="text"
                icon={<LoginOutlined className="mpl-icon-white" />}
                onClick={handleLogin}
                className="mpl-btn-header-desktop"
              >
                <span className="mpl-btn-text-desktop">Login</span>
              </Button>
            )}
          </>
        )}
      </div>

      {/* ─── Insertamos el ContactModal ──────────────────────────────────── */}
      <ContactModal
        visible={isContactModalVisible}
        onCancel={handleContactCancel}
        onDownloadApp={handleDownloadApp}
      />

      {/* ─── Si el usuario pulsa “Descargar App”, mostramos AppDownload ─── */}
      {isAppDownloadVisible && <AppDownload />}
    </div>
  );
}
